import i from "./index.js";
import "./component-DaN8cu97.js";
window.MTRichTextEditor = i;
//# sourceMappingURL=mt-rich-text-editor.js.map
